import { useLocation } from 'react-router-dom';
import { Menu } from '@/components/icons';
import { useTheme } from './useTheme';
import { useAuth } from '@/auth/useAuth';
import { ALL_ITEMS, SIDEBAR_GROUPS, DASHBOARD } from './modules';
import { NotificationBell } from './NotificationBell';
import { useIsMobile } from './useIsMobile';
import { usePageHeader } from './PageHeaderContext';
import { UserMenu } from './UserMenu';

export function Topbar() {
  const { theme, sidebarCollapsed, toggleSidebar } = useTheme();
  const { user } = useAuth();
  const isMobile = useIsMobile();
  const loc = useLocation();
  const current =
    ALL_ITEMS.find((i) => i.path === loc.pathname) ??
    ALL_ITEMS.find((i) => i.path !== '/' && loc.pathname.startsWith(i.path)) ??
    null;
  const currentGroup = current && current.moduleId !== DASHBOARD.moduleId
    ? SIDEBAR_GROUPS.find((g) => g.items.some((i) => i.moduleId === current.moduleId))
    : null;
  // Page-supplied heading takes precedence; falls back to the sidebar label
  // when no page has published one.
  const pageHeader = usePageHeader();
  const headerTitle = pageHeader.title ?? current?.label ?? 'GRHAMOY';
  // The page's group (e.g. "Purchase") under the title; none on the Dashboard.
  const headerSubtitle = pageHeader.subtitle ?? currentGroup?.label ?? null;

  const leftOffset = isMobile ? 0 : sidebarCollapsed ? '64px' : '240px';

  return (
    <div
      className="fixed right-0 top-0 z-30 flex h-12 items-center gap-1 border-b border-[var(--border-color)] px-2 md:h-16 md:gap-4 md:px-6"
      style={{
        left: leftOffset,
        background: theme === 'dark' ? '#171717' : '#fdf6ec',
        boxShadow: theme === 'dark'
          ? '0 2px 10px rgba(0,0,0,0.45)'
          : '0 2px 10px rgba(90,60,20,0.07)',
        transition: 'left 300ms',
      }}
    >
      <button
        onClick={toggleSidebar}
        className="-ml-1 mr-0.5 flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md border topbar-btn text-[var(--text-secondary)] transition hover:text-accent md:h-8 md:w-8 md:rounded-lg"
        title={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        <Menu size={14} strokeWidth={2.5} />
      </button>
      <div className="min-w-0">
        <div className="truncate text-[13px] font-extrabold text-[var(--text-primary)] md:text-[19px]">
          {headerTitle}
        </div>
        {headerSubtitle && (
          <div className="hidden truncate text-[12px] text-[var(--text-muted)] sm:block">
            {headerSubtitle}
          </div>
        )}
      </div>
      <div className="ml-auto flex items-center gap-1 md:gap-3">
        {user && <NotificationBell />}
        {user && <UserMenu />}
      </div>
    </div>
  );
}